import { DEFAULT_PAGE } from '../../constants/pagination';
import {
  MANHOUR_DEFAULT_SORT_ORDER,
  MANHOUR_DEFAULT_SORT_COLUMN,
} from '../../constants/sort';
import { SortOrder } from '../sort/sort';

export interface ManHourGetQueryParams {
  page: number;
  sortOrder: SortOrder;
  sortKey: string;
  employeeId: number | null;
  projectId: number | null;
  month: string | null;
}

export const DefaultManHourGetQueryParams: ManHourGetQueryParams = {
  page: DEFAULT_PAGE,
  sortOrder: MANHOUR_DEFAULT_SORT_ORDER,
  sortKey: MANHOUR_DEFAULT_SORT_COLUMN,
  projectId: null,
  employeeId: null,
  month: null,
};
